module.exports = __webpack_public_path__ + "img/mainSlope.f20c9347.svg";